<p-dialog [header]="('SELECT_PRODUCT' | translate)" [(visible)]="display" [modal]="true" [responsive]="true"
    [breakpoint]="960" (onHide)="onHide()" [style]="{width: '90vw', maxWidth: '1200px'}" [draggable]="false"
    styleClass="product-selector-dialog">

    <div class="product-selection">
        <mat-card *ngFor="let product of products"
            [ngClass]="{'coming-soon': !product.available, 'available': product.available}"
            class="cardWithShadow product-card" (click)="selectProduct(product)">

            <mat-card-content class="product-content">
                <div class="product-image-wrapper">
                    <div class="product-image-container">
                        <img [src]="product.image" alt="{{ product.name | translate }}" class="product-image" />
                    </div>
                </div>

                <div class="product-info">
                    <h3 class="product-title">{{ product.name | translate }}</h3>
                    <p class="product-description" *ngIf="product.description">{{ product.description | translate }}</p>
                </div>

                <div class="product-footer">
                    <div class="product-status">
                        <button *ngIf="product.available" mat-flat-button color="primary" class="select-button">
                            <span>{{ 'START' | translate }}</span>
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</p-dialog>